import { Button } from '@components';
import { closeModal } from '@store/modals';
import { orderStore, setOrderToVoid } from '@store/orders';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { createSignal } from 'solid-js';

export const voidModalId = 'VoidModal';

export const VoidModal = () => {
  const [isVoidingOrder, setIsVoidingOrder] = createSignal<boolean>(false);
  return (
    <>
      <div class="font-semibold ">
        Are you sure you want to void this order?
      </div>
      <div class="flex gap-2 mt-2 justify-end mr-2">
        <Button
          label="Yes"
          onClick={async () => {
            setIsVoidingOrder(true);
            await setOrderToVoid(orderStore.order.id);
            setIsVoidingOrder(false);
            closeModal(voidModalId);
          }}
          disabled={isVoidingOrder()}
          isLoading={isVoidingOrder()}
          dataTestId={formatDataTestId('Yes', 'button')}
        />
        <Button
          label="Cancel"
          onClick={() => closeModal(voidModalId)}
          dataTestId={formatDataTestId('Cancel', 'button')}
        />
      </div>
    </>
  );
};
